import { render, staticRenderFns } from "./Pai2All.vue?vue&type=template&id=0d9834c5&"
import script from "./Pai2All.vue?vue&type=script&lang=js&"
export * from "./Pai2All.vue?vue&type=script&lang=js&"
import style0 from "./Pai2All.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports